import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import dynamic from 'next/dynamic';

import Experiment from '@nubank/www-latam-commons/components/Experiment/Experiment';
import ShortForm from 'patterns/ShortForm/ShortForm';
import ProductPageOpenFormSection from 'patterns/ProductPageOpenFormSection/ProductPageOpenFormSection';
import RegistrationUnavailableLanguage from 'patterns/RegistrationUnavailableLanguage/RegistrationUnavailableLanguage';
import useOpenFormVisibility from 'utils/hooks/useOpenFormVisibility/useOpenFormVisibility';
import { DEFAULT_LOCALE } from 'utils/i18nUtils';
import { PROGRESSIVE_DISCLOSURE_FORM_V2 } from 'utils/experiments';

import { StyledProductPageOpenFormSection } from './styles/ProductPageOpenFormSection';

const ProgressiveDisclosureForm = dynamic(import('patterns/ProgressiveDisclosureForm/ProgressiveDisclosureForm'), { ssr: false });

function SectionForm({ onFormVisibilityChange }) {
  const intl = useIntl();
  const [ref, isFormHidden] = useOpenFormVisibility();

  useEffect(() => {
    onFormVisibilityChange(isFormHidden);
  }, [isFormHidden]);

  return (
    <StyledProductPageOpenFormSection
      ref={ref}
      backgroundImageUrl={{
        xs: {
          '1x': 'man-with-cellphone/man-with-cellphone-xs@1x.jpg',
          '2x': 'man-with-cellphone/man-with-cellphone-xs@2x.jpg',
          '3x': 'man-with-cellphone/man-with-cellphone-xs@3x.jpg',
        },
        md: {
          '1x': 'man-with-cellphone/man-with-cellphone-md@1x.jpg',
          '2x': 'man-with-cellphone/man-with-cellphone-md@2x.jpg',
          '3x': 'man-with-cellphone/man-with-cellphone-md@3x.jpg',
        },
        lg: {
          '1x': 'man-with-cellphone/man-with-cellphone-lg@1x.jpg',
          '2x': 'man-with-cellphone/man-with-cellphone-lg@2x.jpg',
          '3x': 'man-with-cellphone/man-with-cellphone-lg@3x.jpg',
        },
      }}
    >
      <ProductPageOpenFormSection.Container
        gridTemplateRows={{
          xs: '14rem auto 6rem 1fr',
          md: '1fr',
        }}
      >
        <ProductPageOpenFormSection.Heading
          gridColumn={{
            xs: '1 / span 4',
            lg: '2 / span 4',
          }}
          gridRow={{
            xs: '2',
            md: 'initial',
          }}
        >
          <Typography
            variant="title"
            color="white"
            gutterBottom={1}
            intlKey="cms.homePage.homeHeroTitle"
          />
          <Typography
            variant="subtitle"
            color="white"
            gutterBottom={1}
            intlKey="cms.homePage.homeHeroCtaText"
          />
        </ProductPageOpenFormSection.Heading>
        <ProductPageOpenFormSection.FormBlock>
          {intl.locale === DEFAULT_LOCALE ? (
            <Experiment id={PROGRESSIVE_DISCLOSURE_FORM_V2.id}>
              <Experiment.Original>
                <ShortForm />
              </Experiment.Original>
              <Experiment.Variant id={PROGRESSIVE_DISCLOSURE_FORM_V2.emailsFieldsForm}>
                <ProgressiveDisclosureForm completeFormName="completeFormB" />
              </Experiment.Variant>
              <Experiment.Variant
                id={PROGRESSIVE_DISCLOSURE_FORM_V2.emailFieldConfirmationStepForm}
              >
                <ProgressiveDisclosureForm completeFormName="completeFormC" />
              </Experiment.Variant>
            </Experiment>
          ) : (
            <RegistrationUnavailableLanguage isOpenForm isShortForm />
          )}
        </ProductPageOpenFormSection.FormBlock>
      </ProductPageOpenFormSection.Container>
    </StyledProductPageOpenFormSection>
  );
}

SectionForm.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default React.memo(SectionForm);
